module.exports = __webpack_public_path__ + "img/img01.b4b5a419.jpg";